import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "../CsStyles";

import Autocomplete from "@material-ui/lab/Autocomplete";
import { GenericFieldNames } from "../../Constants";
import { Box, Grid, Item, TextField, Typography } from '@material-ui/core';

import AttributeList from "./AttributeList";

import IconButton from '@material-ui/core/IconButton';
import { Delete, ArrowUpward, ArrowDownward, Settings } from '@material-ui/icons';

import Field from "./Bars/Field";
import Loop from "./Bars/Loop";
import Link from "./Bars/Link";

class Bar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            attributesOpen: false
        };

        this.funcs = {
            setName: (name) => {
                this.props.setData(this.props.data.num, { name: name });
            },

            setValue: (value) => {
                this.props.setData(this.props.data.num, { value: value });
            },

            setAttributes: (attributes) => {
                this.props.setData(this.props.data.num, { attributes: attributes });
            },
        };

        this.attributeFuncs = {
            add: (name, value) => {
                if (name.length == 0)
                    return;

                this.funcs.setAttributes([...this.props.data.attributes, { name, value }]);
            },

            remove: (num) => {
                this.funcs.setAttributes([...this.props.data.attributes.slice(0, num), ...this.props.data.attributes.slice(num + 1, this.props.data.attributes.length)]);
            },

            update: (num, property) => {
                var attribute = this.props.data.attributes[num];
                this.funcs.setAttributes([...this.props.data.attributes.slice(0, num), { ...attribute, ...property }, ...this.props.data.attributes.slice(num + 1, this.props.data.attributes.length)]);
            }
        };

        if (this.props.data.name == 'loop') {
            this.kind = Loop;
        }
        else if (this.props.data.name == 'link') {
            this.kind = Link;
        }
        else {
            this.kind = Field;
        }
    }

    render() {
        return (
            <Box
                style={{
                    width: "100%",
                    margin: "1em",
                    border: "1px solid #000",
                    padding: "10px"
                }}
                display='block'>

                <Grid container spacing={2} alignItems="center">
                    <Grid item>
                        <IconButton color="primary" aria-label="delete" component="span">
                            <Delete onClick={() => this.props.funcs.delete(this.props.data.num)} />
                        </IconButton>
                    </Grid>
                    <Grid item>
                        <IconButton color="primary" aria-label="move down" component="span">
                            <ArrowDownward onClick={() => this.props.funcs.moveDown(this.props.data.num)} />
                        </IconButton>
                    </Grid>
                    <Grid item>
                        <IconButton color="primary" aria-label="move up" component="span">
                            <ArrowUpward onClick={() => this.props.funcs.moveUp(this.props.data.num)} />
                        </IconButton>
                    </Grid>
                    {
                        <this.kind name={this.props.data.name} value={this.props.data.value} funcs={this.funcs} />
                    }
                    <Grid>
                        <IconButton color="primary" aria-label="attributes" component="span" style={{ right: "0" }}>
                            <Settings onClick={() => this.setState({ attributesOpen: !this.state.attributesOpen })} />
                        </IconButton>
                    </Grid>
                    <Grid container size={12} >
                        {
                            this.state.attributesOpen && <AttributeList attributes={this.props.data.attributes} funcs={this.attributeFuncs} />
                        }
                    </Grid>
                </Grid>
            </Box>
        );
    }
}

export default withStyles(styles)(Bar);